import hlogistics from '../images/mawada.jpg';
import board from '../images/board.jpg';
import logistics from '../images/logistics.jpg';
import PR from '../images/board_pr.jpg';
import HR from '../images/hr.jpg';
import RD from '../images/r&d.jpg';
import media from '../images/media.jpg';

import '../components/css components/board.css';

function Board(){
    return(
        <div className='board' id='#board'>
            <div className='img-board'>
            <img src={board} alt='board' />
            </div>
            <div className='contain-board'>
                <img src={logistics} alt='logistics' />
                <img src={PR} alt='pr&fr' />
                <img src={HR} alt='pr&fr' />
                <img src={RD} alt='pr&fr' />
                <img src={media} alt='pr&fr' />

            </div>
                {/* <h2 className='title'>Board 2023/2024</h2>
                <div className='top'>
                    <div className='card custom' id='vicel_1'>
                        <img src={viceleader2} alt='tst'/>
                        <h2>Rneem Tamer</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card' id='leader'>
                        <img src={mega} alt='tst'/>
                        <h2>Ahmed Ali</h2>
                        <h3>Team Leader</h3>
                    </div>
                    <div className='card custom' id='vicel_2'>
                        <img src={viceleader1} alt='tst'/>
                        <h2>Ahmed Magdy</h2>
                        <h3>Vice Leader</h3>
                    </div>

                </div>
                <div className='contain'>
                <div className='top'>
                    <div className='card custom' id='vicel_1'>
                        <img src={viceleader2} alt='tst'/>
                        <h2>Rneem Tamer</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card' id='leader'>
                        <img src={mega} alt='tst'/>
                        <h2>Ahmed Ali</h2>
                        <h3>Team Leader</h3>
                    </div>
                    <div className='card custom' id='vicel_2'>
                        <img src={viceleader1} alt='tst'/>
                        <h2>Ahmed Magdy</h2>
                        <h3>Vice Leader</h3>
                    </div>

                </div>
                <div className='top'>

                <div className='card custom' id='vicel_2'>
                        <img src={viceleader1} alt='tst'/>
                        <h2>Ahmed Magdy</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card custom' id='vicel_1'>
                        <img src={viceleader2} alt='tst'/>
                        <h2>Rneem Tamer</h2>
                        <h3>Vice Leader</h3>
                    </div>
                    <div className='card' id='leader'>
                        <img src={mega} alt='tst'/>
                        <h2>Ahmed Ali</h2>
                        <h3>Team Leader</h3>
                    </div>
                    
               

                </div> */}

                
                    {/* <div className='card'>
                        <img src={mega} alt='tst'/>
                        <h3>Team Leader</h3>
                    </div>
                    <div className='card'>
                        <img src={mega} alt='tst'/>
                        <h3>Team Leader</h3>
                    </div> */}
                {/* </div> */}
        </div>
    );
}

export default Board;